// @theme component
import { produce } from 'immer';

import * as Types from './types';
import { actionTypes } from './constants';

export const defaultState: Types.IPragmaticPlayState = {
    tables: {}
};

export const reducer = produce((draftState, action: Types.TPragmaticPlayAction): Types.IPragmaticPlayState | void => {
    switch (action.type) {
        case actionTypes.PRAGMATIC_SET_TABLE_DATA: {
            const { tableId } = action.payload;

            Object.assign(draftState, {
                tables: Object.assign({ ...draftState.tables, ...{ [tableId]: action.payload } })
            });

            break;
        }

        default: {
            break;
        }
    }
}, defaultState);
